import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Header, MainNav } from "./components";
import { UserHelper } from "./helpers";
import { ScreensRouter } from "./screens/ScreensRouter";
import { PlaylistsRouter } from "./playlists/PlaylistsRouter";
import { MessagesRouter } from "./messages/MessagesRouter";
import { SettingsRouter } from "./settings/SettingsRouter";
import { WelcomePage } from "./WelcomePage";
// import UserContext from "./UserContext";

export const Authenticated: React.FC = () => {
  const currentLocation = useLocation();

  if (UserHelper.departmentChanged) {
    UserHelper.departmentChanged = false;
    return <Navigate to="/" replace />
  } else return (
    <>
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#28a745',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#dc3545',
              secondary: '#fff',
            },
          },
        }}
      />
      <Header />
      <MainNav />
      <div className="container-fluid">
        <Routes>
          <Route path="/screens/*" element={<ScreensRouter />} />
          <Route path="/playlists/*" element={<PlaylistsRouter />} />
          <Route path="/messages/*" element={<MessagesRouter />} />
          <Route path="/settings/*" element={<SettingsRouter />} />
          <Route path="/login" element={<Navigate to={currentLocation.pathname} replace />} />
          <Route path="/forgot" element={<Navigate to={currentLocation.pathname} replace />} />
          <Route path="/" element={<WelcomePage />} />
        </Routes>
      </div>
    </>
  );
};